import apiManager from "networking/baseAPIManager";
const getHolidayList = async (params) => {
  const response = await apiManager.holidaylist(params);
  return response;
};

export default getHolidayList;
